import { configureStore } from '@reduxjs/toolkit';
import { authReducer, dataReducer, uiReducer, dashboardReducer } from './slices';

const store = configureStore({
  reducer: {
    auth: authReducer,
    data: dataReducer,
    ui: uiReducer,
    dashboard: dashboardReducer,
  },
});

export default store;
export * from './slices';
export * from './thunks';
export * from './hooks';
